import React, { useState } from 'react';
import {
  Button,
  Container,
  Box,
  Modal,
  Paper,
  TextField,
  Typography,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AddCharacteristics = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [mainCategory, setMainCategory] = useState('');
  const [subCategory, setSubCategory] = useState('');
  const [brand, setBrand] = useState('');
  const [characteristics, setCharacteristics] = useState('');

  const navigate = useNavigate();

  // Static data for dropdowns
  const staticMainCategoryData = [
    { mainCategoryId: 1, mainCategory: 'Electronics' },
    { mainCategoryId: 2, mainCategory: 'Clothing' },
    { mainCategoryId: 3, mainCategory: 'Books' },
    { mainCategoryId: 4, mainCategory: 'Home & Kitchen' },
    { mainCategoryId: 5, mainCategory: 'Sports' },
    { mainCategoryId: 6, mainCategory: 'Toys' },
  ];

  const staticSubCategoryData = {
    'Electronics': [
      { subCategoryId: 1, subCategory: 'Smartphones' },
      { subCategoryId: 2, subCategory: 'Laptops' },
    ],
    'Clothing': [
      { subCategoryId: 3, subCategory: 'Men' },
      { subCategoryId: 4, subCategory: 'Women' },
    ],
    'Books': [
      { subCategoryId: 5, subCategory: 'Fiction' },
      { subCategoryId: 6, subCategory: 'Non-Fiction' },
    ],
    'Home & Kitchen': [
      { subCategoryId: 7, subCategory: 'Appliances' },
      { subCategoryId: 8, subCategory: 'Furniture' },
    ],
    'Sports': [
      { subCategoryId: 9, subCategory: 'Outdoor' },
      { subCategoryId: 10, subCategory: 'Indoor' },
    ],
    'Toys': [
      { subCategoryId: 11, subCategory: 'Educational' },
      { subCategoryId: 12, subCategory: 'Action Figures' },
    ],
  };

  const staticBrandData = {
    'Electronics': {
      'Smartphones': ['Samsung', 'Apple', 'Xiaomi'],
      'Laptops': ['Dell', 'HP', 'Lenovo'],
    },
    'Clothing': {
      'Men': ['Nike', 'Adidas', 'Puma'],
      'Women': ['Zara', 'H&M', 'Gucci'],
    },
    'Books': {
      'Fiction': ['Penguin', 'HarperCollins'],
      'Non-Fiction': ['Random House', 'Simon & Schuster'],
    },
    'Home & Kitchen': {
      'Appliances': ['Whirlpool', 'LG', 'Samsung'],
      'Furniture': ['IKEA', 'Ashley', 'Wayfair'],
    },
    'Sports': {
      'Outdoor': ['Nike', 'Adidas', 'Puma'],
      'Indoor': ['Decathlon', 'Nivia', 'Yonex'],
    },
    'Toys': {
      'Educational': ['LEGO', 'Mattel', 'Hasbro'],
      'Action Figures': ['Marvel', 'DC Comics', 'Star Wars'],
    },
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (mainCategory && subCategory && brand && characteristics) {
      setShowSuccessModal(true);
    } else {
      alert('Please fill all fields');
    }
  };

  const handleCancel = () => {
    setMainCategory('');
    setSubCategory('');
    setBrand('');
    setCharacteristics('');
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '0 auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Add Characteristics
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <div>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel id="main-category-label">Main Category</InputLabel>
            <Select
              labelId="main-category-label"
              id="main-category"
              value={mainCategory}
              label="Main Category"
              onChange={(e) => {
                setMainCategory(e.target.value);
                setSubCategory(''); // Reset subcategory when main category changes
                setBrand(''); // Reset brand when main category changes
              }}
            >
              {staticMainCategoryData.map((category) => (
                <MenuItem key={category.mainCategoryId} value={category.mainCategory}>
                  {category.mainCategory}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel id="sub-category-label">Sub Category</InputLabel>
            <Select
              labelId="sub-category-label"
              id="sub-category"
              value={subCategory}
              label="Sub Category"
              onChange={(e) => {
                setSubCategory(e.target.value);
                setBrand(''); // Reset brand when subcategory changes
              }}
              disabled={!mainCategory}
            >
              {mainCategory && staticSubCategoryData[mainCategory]?.map((subCat) => (
                <MenuItem key={subCat.subCategoryId} value={subCat.subCategory}>
                  {subCat.subCategory}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel id="brand-label">Brand</InputLabel>
            <Select
              labelId="brand-label"
              id="brand"
              value={brand}
              label="Brand"
              onChange={(e) => setBrand(e.target.value)}
              disabled={!subCategory}
            >
              {subCategory && mainCategory && staticBrandData[mainCategory][subCategory]?.map((brandItem) => (
                <MenuItem key={brandItem} value={brandItem}>
                  {brandItem}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Characteristics"
            variant="outlined"
            fullWidth
            value={characteristics}
            onChange={(e) => setCharacteristics(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={
            !mainCategory ? "Select Main Category" :
            !subCategory ? "Select Sub Category" :
            !brand ? "Select Brand" :
            !characteristics ? "Enter Characteristics" : ""
          } arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleSave}
                sx={{
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!mainCategory || !subCategory || !brand || !characteristics}
              >
                SAVE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            RESET
          </Button>
        </div>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Characteristics Added ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Characteristics Added Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default AddCharacteristics;
